import React from "react";
import Avatar from "@mui/material/Avatar";
import propTypes from "prop-types";
import "../assets/styles/components/Cast.scss";

const Cast = (props) => {
  const { data } = props;
  const { known_for_department, original_name, profile_path, character } = data;

  return (

      <div className="cast">
        <Avatar
          sx={{ width: 120, height: 120 }}
          alt={original_name}
          src={
            profile_path ? `https://image.tmdb.org/t/p/w500${profile_path}` : ""
          }
        />
        <p className="cast-name">{original_name}</p>
        <p className="cast-character">{character}</p>
        <p className="cast-character">{known_for_department}</p>
      </div>
  );
};

// propsTypes
Cast.propTypes = {
  data: propTypes.object,
  // // title: propTypes.string,
  // // overview: propTypes.string,
  // // id: propTypes.number
  //etc etc solo documentacón
};

export default Cast;
